/**
 * InterviewReadinessCard — dashboard promo card for the new Interview
 * Readiness foundation. Static, no fake progress / scores / AI feedback.
 * Routes to /interview-readiness.
 */
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserCheck } from 'lucide-react';

export function InterviewReadinessCard({ navigate }) {
  return (
    <Card
      className="p-6 border border-slate-200 shadow-sm rounded-2xl"
      data-testid="interview-readiness-card"
    >
      <div className="flex gap-4">
        <div className="w-12 h-12 rounded-xl bg-brand-light flex items-center justify-center flex-shrink-0">
          <UserCheck className="w-6 h-6 text-brand" strokeWidth={1.8} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="text-lg font-bold text-slate-900">Prepare / Interview Readiness</h3>
            <span
              data-testid="interview-readiness-badge"
              className="flex-shrink-0 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-brand-light text-brand"
            >
              New
            </span>
          </div>
          <p className="text-sm text-slate-500 leading-relaxed mb-5">
            Get ready for civilian interviews. Start with fundamentals, STAR method,
            leadership translation, and practice.
          </p>
          <Button
            data-testid="start-interview-readiness-btn"
            onClick={() => navigate('/interview-readiness')}
            variant="outline"
            className="w-full border-brand text-brand hover:bg-brand hover:text-white font-semibold"
          >
            Start interview readiness
          </Button>
        </div>
      </div>
    </Card>
  );
}

export default InterviewReadinessCard;
